import {
  Box,
  Typography,
  Card,
  CardContent,
  LinearProgress,
  CardActions,
  Button,
} from '@mui/material';
import { UseFormReturnType } from '@refinedev/react-hook-form';
import { useTranslation } from 'react-i18next';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { SubmitButton } from './SubmitButton';
import { FieldValues } from 'react-hook-form';
import { BaseRecord, HttpError, useBack } from '@refinedev/core';

export const FormWrapper = <
  TQuery extends BaseRecord,
  TVariable extends FieldValues,
>({
  form,
  title,
  description,
  children,
}: {
  form: UseFormReturnType<TQuery, HttpError, TVariable>;
  title?: string;
  description?: string;
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const goBack = useBack();
  const isLoading = form.refineCore?.formLoading;

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 1 }}>
      {/* Header with back button */}
      <Box sx={{ mb: 3, gap: 2 }}>
        <Button
          onClick={goBack}
          sx={{ mr: 2 }}
          aria-label={t('buttons.back')}
          startIcon={<ArrowBackIcon />}
        >
          {t('buttons.back')}
        </Button>
        {title && (
          <Typography variant="h4" component="h1" gutterBottom>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>

      {/* Form Card */}
      <Card
        elevation={2}
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <CardContent sx={{ p: 3 }}>
          {isLoading && <LinearProgress sx={{ mb: 2 }} />}

          {children}
        </CardContent>

        {/* Action buttons */}
        <CardActions sx={{ p: 3, pt: 0, justifyContent: 'flex-end', gap: 1 }}>
          <SubmitButton form={form} />
        </CardActions>
      </Card>
    </Box>
  );
};
